<template>
  <v-container class="main" v-resize="adjust_size" pa-0>
    <v-container pa-0
      v-bind:class="{ 'header': true, 'large': (screen.x > 950), 'small': (screen.x < 950), 'mobile': (screen.x <= 450) }">
      <v-layout row>
        <v-flex xs11 pa-0 pl-3 pt-3>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex pt-3 xs12 class="subtitle-text">THE LEADING</v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 v-bind:class="{ 'title-text': screen.x > 450, 'title-text-mobile': screen.x <= 450 }">SWEATER AND
          GARMENT MANUFACTURER</v-flex>
      </v-layout>
    </v-container>
    <v-layout justify-space-around pt-2>
      <v-flex v-bind:class="{ 'carousel-normal': screen.x > 450, 'carousel-mobile': screen.x <= 450 }">
        <v-carousel v-bind:class="{ 'carousel-normal': screen.x > 450, 'carousel-mobile': screen.x <= 450 }"
          hide-delimiters style="box-shadow: none" transition="v-slide-transition">
          <v-carousel-item v-for="photo in this.prod_photos" v-bind:src="(screen.x > 450) ? photo.src : photo.msrc"
            :key="photo.id" transition="fade" reverse-transition="fade">
          </v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>
    <v-container class="main-text" pa-0>
      <v-layout justify-center>
        <v-flex xs9>
          <v-card-text class="details" v-for="sentence in this.text.tentangKami" :key="sentence.id"
            v-bind:class="{ 'large-text': (screen.x > 950), 'small-text': (screen.x < 950 && screen.x > 450), 'mobile-text': (screen.x <= 450) }">
            {{ sentence.data }}
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
    <split-text :texts="text.Visi" :screen="screen" />
    <split-text :texts="text.Misi" :screen="screen" />
    <split-text :texts="text.Divisi" :screen="screen" />
    <maps :marker="marker" :screen="screen" />
    <split-text :texts="text.Kontak" :screen="screen" />
  </v-container>
</template>

<script>
import SplitText from './SplitText.vue'
import Maps from './Maps.vue'
export default {
  name: 'MainPage',
  data() {
    return {
      screen: {
        x: 0,
        y: 0
      },
      prod_photos: [
        {
          id: 1,
          src: 'http://dater-garment.com/img/frontview.jpg',
          msrc: 'http://dater-garment.com/img/frontview-mobile.jpg'
        },
        {
          id: 2,
          src: 'http://dater-garment.com/img/bottomroom.jpg',
          msrc: 'http://dater-garment.com/img/bottomroom-mobile.jpg'
        },
        {
          id: 3,
          src: 'http://dater-garment.com/img/mainroom.jpg',
          msrc: 'http://dater-garment.com/img/mainroom-mobile.jpg'
        },
      ],
      marker: {
        position: { lat: -6.992385, lng: 107.850855 }
      },
      text: {
        tentangKami: [
          {
            id: 1,
            data: 'PT DATER GARMENT INDUSTRI adalah perusahaan yang bergerak di bidang clothing manufacture, kami memproduksi rajutan sweater, kaos,seragam polo shirt dan jaket khusus dari bahan knitting,baik jasa FOB maupun CMT.'
          },
          {
            id: 2,
            data: 'Banyak perusahaan yang telah bekerja sama dengan kami dan membangun hubungan yang  profesional dengan kami dan memberikan kesempatan kepada kami untuk memproduksi beragam atasan dari benang menjadi Sweater atau dari kain menjadi Garment Knitting untuk kebutuhan Brand2 mereka (local market)'
          },
          {
            id: 3,
            data: 'Dalam menghasilkan produk yang berkualitas tinggi kami didukung oleh teknologi dan tenaga kerja ahli yang kompeten di bidangnya masing-masing.'
          }
        ],
        Visi: [
          {
            id: 1,
            header: 'Visi',
            datas: [
              { id: 1, string: 'Terus tumbuh dan berkembang menjadi perusahaan jasa produksi clothing terbaik di Indonesia.' }
            ]

          }
        ],
        Misi: [
          {
            id: 1,
            header: 'Misi',
            datas: [
              { id: 1, string: 'Memberikan nilai terbaik bagi para pelanggan kami dengan dukungan teknologi, kualitas produk, harga yang bersaing  dan ketepatan waktu produksi.' },
              { id: 2, string: 'Memberikan inovasi dan kreativitas untuk memenuhi kebutuhan pelanggan kami.' },
              { id: 3, string: 'Menciptakan lapangan kerja bagi pekerja Indonesia.' },
              { id: 4, string: 'Melalui tindakan perbaikan, kami tumbuh untuk memenuhi kebutuhan pelanggan kami.' }
            ]
          }
        ],
        Kontak: [
          {
            id: 1,
            header: 'Temukan Kami',
            datas: [
              { id: 1, string: 'Kampung Bojong Asih' },
              { id: 2, string: 'Rt 003 Rw 008 (Km 31.5)' },
              { id: 3, string: 'Kecamatan Cicalengka WetanCicalengka' },
              { id: 4, string: 'Kab. Bandung' },
              { id: 5, string: '40395' }
            ]


          },
          {
            id: 2,
            header: 'Hubungi Kami',
            datas: [
              { id: 1, string: '0812 140 6001' },
              { id: 2, string: 'lusiana@dater-garment.com' }
            ],
            whatsapp: 'https://wa.me/628121406001'
          }
        ],
        Divisi: [
          {
            id: 1,
            header: 'Sweater',
            datas: [
              { id: 1, string: 'menawarkan jasa untuk memproduksi rajutan Mens, Ladies, Childrens dan Babies' },
              { id: 2, string: 'divisi sweater kami memiliki kapasitas untuk memproduksi sampai dengan 50,000 pcs/bulan dan kami juga melayani pesanan dengan minimum order 480 pcs per item.' },
              { id: 3, string: 'Mesin rajut computerized kami dapat memproduksi dari 3 gg sampai 12 gg.' }
            ]
          },
          {
            id: 2,
            header: 'Garment',
            datas: [
              { id: 1, string: 'menawarkan jasa untuk memproduksi kaos, polo shirt , jaket dan celana traning untuk ladies, mens dan kids. ' },
              { id: 2, string: 'Untuk kaos perbulan kami dapat memproduksi sampai dengan 50,000 pcs. Untuk jaket kami dapat memproduksi 5,000 pcs. ' }
            ]
          }
        ]
      }
    }
  },
  beforeMount() {
    this.adjust_size()
  },
  methods: {
    adjust_size() {
      this.screen = { x: window.innerWidth, y: window.innerHeight }
    }
  },
  components: {
    SplitText,
    Maps
  }
}
</script>

<style>
.page {
  padding-top: 2%;
  padding-bottom: 2%;
}

.main {
  max-width: 100%;
}

.main-text {
  transform: translateY(1.5em)
}

.carousel-normal {
  box-shadow: none;
}

.carousel-mobile {
  max-height: 15em !important;
  box-shadow: none;
}

.subtitle-text {
  font-family: 'Raleway', sans-serif;
  font-size: 1.575em;
  text-align: center;
}

.title-text {
  font-family: 'Raleway', sans-serif;
  font-size: 2.125em;
  font-weight: bold;
  text-align: center
}

.title-text-mobile {
  font-family: 'Raleway', sans-serif;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center
}

.details {
  color: #595d64;
  text-align: center;
}

.small-text {
  font-size: 0.7em
}

.large-text {
  font-size: 1em;
}

.mobile-text {
  font-size: 0.8em;
  word-wrap: break-word;
  text-align: center;
}

.subtitle-text {
  font-family: 'Raleway', sans-serif;
  font-size: 1em;
  font-weight: bold;
}

.title-text {
  font-family: 'Raleway', sans-serif;
  font-size: 2.125em;
  font-weight: bold;
}

.location {
  padding-top: 0.5em
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue